import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {
  ServiceBillingDetail,
  ServiceBillingDetailFilter,
  ServiceBillingDetailInput
} from './service-billing-detail.model';

export const loadServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] Load ServiceBillingDetails',
  props<{ serviceBillingDetails: ServiceBillingDetail[] }>()
);

export const addServiceBillingDetail = createAction(
  '[ServiceBillingDetail/API] Add ServiceBillingDetail',
  props<{ serviceBillingDetail: ServiceBillingDetail }>()
);

export const upsertServiceBillingDetail = createAction(
  '[ServiceBillingDetail/API] Upsert ServiceBillingDetail',
  props<{ serviceBillingDetail: ServiceBillingDetail }>()
);

export const addServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] Add ServiceBillingDetails',
  props<{ serviceBillingDetails: ServiceBillingDetail[] }>()
);

export const upsertServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] Upsert ServiceBillingDetails',
  props<{ serviceBillingDetails: ServiceBillingDetail[] }>()
);

export const updateServiceBillingDetail = createAction(
  '[ServiceBillingDetail/API] Update ServiceBillingDetail',
  props<{ serviceBillingDetail: Update<ServiceBillingDetail> }>()
);

export const updateServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] Update ServiceBillingDetails',
  props<{ serviceBillingDetails: Update<ServiceBillingDetail>[] }>()
);

export const deleteServiceBillingDetail = createAction(
  '[ServiceBillingDetail/API] Delete ServiceBillingDetail',
  props<{ id: string }>()
);

export const deleteServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] Delete ServiceBillingDetails',
  props<{ ids: string[] }>()
);

export const clearServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] Clear ServiceBillingDetails'
);

// CUSTOM
export const createServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] create ServiceBillingDetail',
  props<{ input: ServiceBillingDetailInput }>()
);


export const editServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] edit ServiceBillingDetail',
  props<{ input: ServiceBillingDetailInput }>()
);

export const removeServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] remove ServiceBillingDetail',
  props<{ billingUniqueId: string, id: string }>()
);

export const getServiceBillingDetails = createAction(
  '[ServiceBillingDetail/API] get ServiceBillingDetail',
  props<{ filtering: ServiceBillingDetailFilter }>()
);

export const citizenGetInstitutionServiceBillings = createAction(
  '[ServiceBillingDetail/API] citizen get ServiceBillingDetail',
  props<{ filtering: ServiceBillingDetailFilter }>()
);
